import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./ChequeBookRequest.css";
import { Box, Divider, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  root1: {
    width: "100%",
    maxWidth: 360,
    // backgroundColor: theme.palette.background.paper,
  },
  root2: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2),
    },
  },
  buttonRoot: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  msText: {
    "&.MuiTypography-body1": {
      fontWeight: 600,
    },
  },
}));

export default function ChequeBookRequest(props) {
  // const classes = useStyles();

  let masked_accountNo;
  let request_status;
  props.chequeBookRequestData.map((item, i) => {
    // console.log("DATA: ", item);
    masked_accountNo = item.Body.Payload.Account_Number;
    request_status = item.Body.Payload.Status;
  });

  let confirmMessage = `The Cheque Book Request Has Been Recieved for Account Number ${masked_accountNo}`;
  let rejectedMessage = `The Cheque Book Request Has Not Been Recieved for Account Number ${masked_accountNo}`;

  return (
    <>
      <div id="background" className="cbr-content-wrapper cbr-content-wrapper-bot cbr-content-wrapper-border cbr-width-70"style={{ border: "8px solid rgba(244, 176, 53, 0.8)" ,backgroundColor:"rgba(245, 243, 243, 1) !important" ,width: "83% !important"
      }}>
        <Box>
          <Typography align="center" variant="subtitle2" display="block" style={{ color: "rgba(12, 77, 162, 1)", fontSize: "18px" ,textAlign:"center",fontWeight:"600"}}>
            Cheque Book Request Status
          </Typography>
        </Box>
        <Divider variant="middle" />
        <Box className="box-message">
          {request_status == "O.K." && (
            <Typography align="center" component="subtitle1">
              {confirmMessage}
            </Typography>
          )}
          {!request_status == "O.K." && (
            <Typography align="center" component="subtitle1">
              {rejectedMessage}
            </Typography>
          )}
        </Box>
      </div>
    </>
  );
}
